import { render, staticRenderFns } from "./BalanceGT.vue?vue&type=template&id=6d682cd2&scoped=true&"
import script from "./BalanceGT.vue?vue&type=script&lang=js&"
export * from "./BalanceGT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d682cd2",
  null
  
)

export default component.exports